export default function History(props) {
  return (
    <svg
      id="Icon_awesome-history"
      data-name="Icon awesome-history"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      {...props}>
      <path
        id="Icon_awesome-history-2"
        data-name="Icon awesome-history"
        d="M20.562,10.544a10,10,0,0,1-16.276,7.8.967.967,0,0,1-.074-1.436l.454-.454a.969.969,0,0,1,1.286-.08A7.42,7.42,0,1,0,5.479,5.157L7.526,7.2a.645.645,0,0,1-.456,1.1H1.208a.645.645,0,0,1-.645-.645V1.8a.645.645,0,0,1,1.1-.456L3.655,3.332a10,10,0,0,1,16.908,7.212ZM13.268,13.72l.4-.509a.968.968,0,0,0-.17-1.358l-1.641-1.276V6.369a.968.968,0,0,0-.968-.968H10.24a.968.968,0,0,0-.968.968v5.47L11.91,13.89A.968.968,0,0,0,13.268,13.72Z"
        transform="translate(-0.563 -0.563)"
        fill="#fff"
      />
    </svg>
  );
}
